import Vue from 'vue';
import moment from 'moment';

Vue.filter('data', (data) => {
    if (data) {
        return moment.utc(String(data)).format('DD/MM/YYYY');
    }
    return '-';
});

Vue.filter('ellipsis', (valor, tamanhoPrefixo, tamanhoSufixo) => {
    if (!valor) {
        return '-';
    }
    valor = String(valor);
    const tamanho = valor.length;
    if (tamanho <= tamanhoPrefixo + tamanhoSufixo) {
        return valor;
    }
    return `${valor.substring(0, tamanhoPrefixo)} ... ${valor.substring(tamanho - tamanhoSufixo, tamanho)}`;
});

Vue.filter('decimal', (valor, sufixo = '', precisao = 2) => {
    if (valor === undefined || valor === null) {
        return '-';
    }

    const numero = Number(valor);

    if (Number.isNaN(numero)) {
        return valor;
    }

    const formatado = numero.toLocaleString('pt-BR', {
        maximumFractionDigits: precisao,
        minimumFractionDigits: precisao,
        roundingMode: 'halfEven'
    });

    if (sufixo) {
        return `${formatado} ${sufixo}`;
    }

    return formatado;
});

Vue.filter('enum', (valor, dicionario) => {
    if (valor === undefined || valor === null) {
        return '-';
    }

    return dicionario[valor]?.nome ?? '-';
});
